import { opStatusClass, payStatusClass } from "@/lib/format";

export function OpBadge({ status }) {
  return (
    <span
      data-testid="op-status-badge"
      className={`inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-semibold ${opStatusClass(status)}`}
    >
      {status}
    </span>
  );
}

export function PayBadge({ status }) {
  return (
    <span
      data-testid="pay-status-badge"
      className={`inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-semibold ${payStatusClass(status)}`}
    >
      {status}
    </span>
  );
}
